export const REPORTS = {
  // ReportsLibrary elements
  FEATURE_FLAG_LEARN_MORE_BUTTON: 'reports-feature-flag-learn-more-button',
  SELECT_PROJECTS_BUTTON: 'reports-select-projects-button',
  EMPTY_STATE_LEARN_MORE_BUTTON: 'reports-empty-state-learn-more-button',

  // ReportsHeader elements
  REFRESH_STALE_REPORT_BUTTON: 'reports-refresh-stale-report-button',
  PROJECT_DROPDOWN_BUTTON: 'reports-project-dropdown-button',

  // ReportsHeaderMoreMenu elements
  MORE_MENU_BUTTON: 'reports-more-menu-button',
  SAVE_CHANGES_MENU_ITEM: 'reports-save-changes-menu-item',
  CREATE_NEW_REPORT_MENU_ITEM: 'reports-create-new-report-menu-item',
  REPORT_MENU_ITEM: 'reports-report-menu-item',
  REPORT_MORE_MENU_BUTTON: 'reports-report-more-menu-button',
  RENAME_MENU_ITEM: 'reports-rename-menu-item',
  DUPLICATE_MENU_ITEM: 'reports-duplicate-menu-item',
  DELETE_MENU_ITEM: 'reports-delete-menu-item',
  LIVE_DATA_MENU_ITEM: 'reports-live-data-menu-item',
  DEMO_DATA_MENU_ITEM: 'reports-demo-data-menu-item',

  // ReportProjectSelectionTable elements
  PROJECT_CHECKBOX: 'reports-project-checkbox',
  ADD_MORE_PROJECTS_BUTTON: 'reports-add-more-projects-button',

  // ReportDeleteDialog elements
  DELETE_DIALOG_CLOSE_BUTTON: 'reports-delete-dialog-close-button',
  DELETE_DIALOG_NO_BUTTON: 'reports-delete-dialog-no-button',
  DELETE_DIALOG_YES_BUTTON: 'reports-delete-dialog-yes-button',

  // ReportNameDialog elements
  NAME_DIALOG_CLOSE_BUTTON: 'reports-name-dialog-close-button',
  NAME_DIALOG_TEXT_FIELD: 'reports-name-dialog-text-field',
  NAME_DIALOG_CANCEL_BUTTON: 'reports-name-dialog-cancel-button',
  NAME_DIALOG_CREATE_BUTTON: 'reports-name-dialog-create-button',

  // ReportSelectProjectDialog elements
  SELECT_PROJECT_DIALOG_CLOSE_BUTTON: 'reports-select-project-dialog-close-button',
  SELECT_PROJECT_DIALOG_CANCEL_BUTTON: 'reports-select-project-dialog-cancel-button',
  SELECT_PROJECT_DIALOG_CREATE_BUTTON: 'reports-select-project-dialog-create-button',

  // SelectVersionCellRenderer elements
  VERSION_DROPDOWN_PILL: 'reports-version-dropdown-pill',
  VERSION_CURRENT_OPTION: 'reports-version-current-option',
  VERSION_BASELINE_OPTION: 'reports-version-baseline-option',
  VERSION_OTHER_OPTION: 'reports-version-other-option'
} as const;
